import { render, staticRenderFns } from "./CardInquiry.vue?vue&type=template&id=f6d442d2"
import script from "./CardInquiry.vue?vue&type=script&lang=js"
export * from "./CardInquiry.vue?vue&type=script&lang=js"
import style0 from "./CardInquiry.vue?vue&type=style&index=0&id=f6d442d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports